// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2ojz3","emails":"CreateEditClinics_emails__gDUml","emailTagLabel":"CreateEditClinics_emailTagLabel__3HQAq"};